import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { ButtonModule } from 'primeng/button';
import { MenubarModule } from 'primeng/menubar';
import { InputTextModule } from 'primeng/inputtext';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { LoadingComponent } from './components/loading/loading.component';
import { OptInputComponent } from './components/opt-input/opt-input.component';
import { PinInputComponent } from './components/pin-input/pin-input.component';
import { AutoFocusModule } from 'primeng/autofocus';
import { FormsModule } from '@angular/forms';
import { StepsModule } from 'primeng/steps';
import { CoinSwitchComponent } from './components/coin-switch/coin-switch.component';
import { NumericInputMaskDirective } from './directives/numeric-input-mask.directive';
import { CurrencyMaskPipe } from './pipes/currency-mask.pipe';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { ErrorModalComponent } from './components/error-modal/error-modal.component';
import { WarningToastComponent } from './components/warning-toast/warning-toast.component';
import { InfoAlertCardComponent } from './components/info-alert-card/info-alert-card.component';
import { RefreshTokenModalComponent } from './components/refresh-token-modal/refresh-token-modal.component';
import { OnlyNumbersDirective } from './directives/only-numbers.directive';
import { AlphanumericOnlyDirective } from './directives/alphanumeric-only.directive';
import { UnsubscribeComponent } from './components/unsubscribe/unsubscribe.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { InfoModalComponent } from './components/info-modal/info-modal.component';
import { NotificationsPanelComponent } from './components/notifications-panel/notifications-panel.component';
import { NotificationsModalComponent } from './components/notifications-modal/notifications-modal.component';
import { QuizModalComponent } from './components/quiz-modal/quiz-modal.component';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { DialogDefaultsDirective } from './directives/dialog-defaults.directive';
import { PhoneValidatorDirective } from './directives/phone-validator.directive';
import { BackButtonComponent } from './components/back-button/back-button.component';

@NgModule({
  declarations: [
    NumericInputMaskDirective,
    CurrencyMaskPipe,
    AlphanumericOnlyDirective,
  ],
  imports: [
    CommonModule,
    ButtonModule,
    MenubarModule,
    InputTextModule,
    TieredMenuModule,
    AutoFocusModule,
    FormsModule,
    StepsModule,
    DialogModule,
    ToastModule,
    TooltipModule,
    DialogDefaultsDirective,
    PhoneValidatorDirective,
    OnlyNumbersDirective,
    HeaderComponent,
    LoadingComponent,
    OptInputComponent,
    PinInputComponent,
    CoinSwitchComponent,
    ErrorModalComponent,
    WarningToastComponent,
    InfoAlertCardComponent,
    RefreshTokenModalComponent,
    UnsubscribeComponent,
    StepperComponent,
    InfoModalComponent,
    NotificationsPanelComponent,
    NotificationsModalComponent,
    QuizModalComponent,
    TimeAgoPipe,
    BackButtonComponent,
  ],
  exports: [
    HeaderComponent,
    LoadingComponent,
    OptInputComponent,
    PinInputComponent,
    CoinSwitchComponent,
    NumericInputMaskDirective,
    CurrencyMaskPipe,
    ErrorModalComponent,
    WarningToastComponent,
    InfoAlertCardComponent,
    RefreshTokenModalComponent,
    OnlyNumbersDirective,
    AlphanumericOnlyDirective,
    UnsubscribeComponent,
    StepperComponent,
    InfoModalComponent,
    NotificationsPanelComponent,
    NotificationsModalComponent,
    QuizModalComponent,
    TimeAgoPipe,
    TooltipModule,
    DialogDefaultsDirective,
    PhoneValidatorDirective,
    BackButtonComponent,
  ],
})
export class SharedModule {}
